import { motion } from "framer-motion";
import logo from "../../assets/logo-dominus-vetorizada.png"; // Importando a imagem do logo

export function IntroAnimation({ onComplete }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black">
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }} //inicia na escala 0.5 com a opacidade 0
        animate={{ opacity: 1, scale: 1 }} //termina na escala 1 com a opaciadade no 1
        transition={{ duration: 1 }} // faz com que a transição dure 1seg
        className="relative w-64 h-64 md:w-80 md:h-80"
      >
        <img
          src={logo}
          alt="DOMINUS TECH"
          className="w-full h-full object-contain"
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }} //inicia com sua opacidade no 0 e com o item na posição 20 dentro do eixo y
        animate={{ opacity: 1, y: 0 }} //finaliza com sua opacidade no 1 e com o item na posição 0 dentro do eixo y
        transition={{ delay: 1, duration: 0.8 }} //cria um delay de 1seg referente as animações anteriores e com uma duração de 0.8
        className="mt-8 text-center"
      >
        <motion.h1
          className="text-3xl md:text-4xl font-bold text-gray-300"
          initial={{ opacity: 0 }} //inicia na opacidade 0
          animate={{ opacity: 1 }} // finaliza na opacidade 1
          transition={{ delay: 1.5, duration: 1 }} //cria um delay de 1.5seg referente as animações anteriores
        >
          Bem-vindo à DOMINUS TECH
        </motion.h1>

        <motion.p
          className="mt-4 text-lg text-gray-200"
          initial={{ opacity: 0 }} //inicia na opacidade 0
          animate={{ opacity: 1 }} // finaliza na opacidade 1
          transition={{ delay: 2, duration: 0.8 }} //cria um delay de 2seg referente as animações anteriores
        >
          Sua loja de tecnologia de confiança
        </motion.p>
      </motion.div>

      <motion.div
        initial={{ width: 0 }}
        animate={{ width: "60%" }}
        transition={{ delay: 2.5, duration: 1 }}
        className="h-1 bg-green-500 mt-8 rounded-full"
        onAnimationComplete={onComplete}
      />
    </div>
  );
}
